import createDuck from '../lib/MetagnosticDuck'
import { getCity, getCities } from '../lib/APIClient'

// @TODO using the city name as Id is very dangerous

export const emptyCity = {
  _id: "",
  chinese: "",
  name: null,
  country: "Spain",
  address: null,
  files: { dayBg: null, descriptionPDF: null },
  fileNotes: {},
  stations: {},
  preciseLocation: {
    address: "",
    latitude: null,
    longitude: null,
    queryAddress : null,
  },
  notes: "",
}

const rehydrate = c => ({
  ...emptyCity,
  ...c,
  files: { ...emptyCity.files, ...c.files },
  name: c.name || c._id,
  _id: c._id || c.name,
})


/**
 *
 */

const duck = createDuck(
  "CITIES",
  getCity,
  getCities,
  {
    // #TODO custom remove action (that just says "NOPE")
  },
  emptyCity,
  null,
  { customRehydrate: rehydrate, expunge: true }
)

export const createCity = duck.actions.createDoc
export const receiveCities = duck.actions.receiveCollection
export const receiveCity = duck.actions.receiveDoc
export const fetchCities = duck.actions.fetchCollection
export const updateCity = duck.actions.updateDoc

export const removeCity = () => console.error("NOT IMPLEMENTED: cities can't be removed :D")

export default duck
